<script setup lang="ts">
import { ref, computed, watch, type Ref, inject } from 'vue'
import { useRouter } from 'vue-router'
import { SuiButton, SuiDropdown, SuiForm } from 'vue-fomantic-ui'
import { useContainerTypeStore } from '@/stores/container_types'
import type { ContainerType } from '@/models/ContainerType'
import FadeTransition from '@/components/FadeTransition.vue'
import Title from '@/components/Title.vue'

const router = useRouter()
const containerTypeStore = useContainerTypeStore()

const containerType = inject('containerType') as Ref<ContainerType | null>

/* Dropdowns */

const selectedWasteType = ref()
const selectedVolume = ref()

const wasteTypes = containerTypeStore.wasteTypes.map((type) => ({
  text: type.name,
  value: type,
}))
const volumes = computed(() => {
  return containerTypeStore.getVolumes(selectedWasteType.value?.value).map((volume) => ({
    text: `${volume} L`,
    value: volume,
  }))
})

watch(selectedWasteType, () => {
  removeError('wasteType')

  if (
    selectedVolume.value &&
    !selectedWasteType.value.value.volumes.includes(selectedVolume.value.value)
  ) {
    selectedVolume.value = null
  }
})

watch(selectedVolume, () => removeError('volume'))

/* Form validation */

const errors: Ref<string[]> = ref([])

const removeError = (error: string) => {
  if (errors.value.includes(error)) {
    //errors.value = errors.value.filter(e => e !== error)
    errors.value.splice(errors.value.indexOf(error), 1)
  }
}

const checkForm = () => {
  errors.value = []

  if (!selectedWasteType.value) {
    errors.value.push('wasteType')
  }

  if (!selectedVolume.value) {
    errors.value.push('volume')
  }

  return errors.value.length === 0
}

/* Save */

const next = () => {
  if (!checkForm()) return

  containerType.value = containerTypeStore.findByWasteTypeAndVolume(
    selectedWasteType.value.value,
    selectedVolume.value.value,
  )

  router.push({ name: 'add-container-scan' })
}
</script>

<template>
  <div class="page add-container-type">
    <FadeTransition>
      <Title>Ajouter des bacs</Title>
    </FadeTransition>
    <SuiForm @submit.prevent="next">
      <p>Sélectionner le type de bac et la contenance</p>
      <div :class="{ field: true, 'waste-type': true, error: errors.includes('wasteType') }">
        <SuiDropdown
          :options="wasteTypes"
          v-model="selectedWasteType"
          placeholder="Type de bac"
          selection
        />
      </div>
      <div :class="{ field: true, volume: true, error: errors.includes('volume') }">
        <SuiDropdown
          :options="volumes"
          v-model="selectedVolume"
          placeholder="Contenance"
          selection
        />
      </div>
      <SuiButton class="submit" type="submit">Continuer</SuiButton>
    </SuiForm>
  </div>
</template>

<style scoped lang="scss">
.add-container-type {
  p,
  .field {
    margin: 2dvh 0;
  }

  p {
    text-align: center;
  }
  .field {
    width: 100%;
  }
}

/* @TODO: override Fomantic styles in a cleaner way */
.ui.form {
  min-height: 67.5dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90%;
  padding: 2dvh 0;
}
.ui.button {
  font-family: 'Libre Franklin', sans-serif;
  padding: 8px 20px 7px 20px;
  background-color: #344c60;
  transition: opacity 0.25s;
  color: white;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  height: 40px;
  width: 60%;
  line-height: 22px;
  margin-top: auto;
  margin-bottom: 20px;
}
</style>
